var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDistance01 = function SvgIconDistance01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_distance-01_svg2__a",
    x1: -28.54,
    x2: 83.62,
    y1: 50.57,
    y2: -13.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_distance-01_svg2__a",
    id: "icon_distance-01_svg2__b",
    x1: -30.37,
    x2: 81.8,
    y1: 47.38,
    y2: -16.72
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_distance-01_svg2__a",
    id: "icon_distance-01_svg2__c",
    x1: 0.96,
    x2: 113.12,
    y1: 102.2,
    y2: 38.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_distance-01_svg2__a",
    id: "icon_distance-01_svg2__d",
    x1: -0.87,
    x2: 111.3,
    y1: 99,
    y2: 34.91
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_distance-01_svg2__a",
    id: "icon_distance-01_svg2__e",
    x1: 1.57,
    x2: 113.74,
    y1: 103.27,
    y2: 39.17
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M16.97 47.68c.28.27 1.11 1.09 2.38 1.09h.04c1.26 0 2.1-.82 2.38-1.09l.05-.05C29.46 39.6 43.68 24.66 35.87 9.8v-.02C32.67 3.86 26.36.11 19.39 0h-.07C12.36.11 6.05 3.86 2.86 9.8c-7.81 14.85 6.41 29.8 14.05 37.83l.05.05ZM6.66 11.82c2.44-4.55 7.3-7.42 12.7-7.52 5.4.09 10.26 2.97 12.7 7.51 5.73 10.92-3.38 22.28-12.7 32.15C10.04 34.09.93 22.73 6.66 11.82",
    style: {
      fill: "url(#icon_distance-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.77 18.97c0-5.75-4.66-10.41-10.42-10.41-5.75 0-10.41 4.66-10.41 10.42 0 5.75 4.66 10.41 10.42 10.41 5.75 0 10.41-4.67 10.41-10.42m-16.53 0a6.12 6.12 0 1 1 6.12 6.12c-3.38 0-6.11-2.74-6.12-6.12",
    style: {
      fill: "url(#icon_distance-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.25 81.14c.28.27 1.11 1.09 2.38 1.09h.04c1.26 0 2.1-.82 2.38-1.09l.05-.05c7.64-8.03 21.86-22.97 14.05-37.83v-.02c-3.19-5.93-9.49-9.68-16.46-9.79h-.07c-6.97.11-13.28 3.86-16.46 9.8-7.81 14.85 6.41 29.8 14.05 37.83l.05.05ZM67.94 45.28c2.44-4.55 7.3-7.42 12.7-7.52 5.4.09 10.26 2.97 12.7 7.51 5.73 10.92-3.38 22.28-12.7 32.15-9.32-9.87-18.43-21.23-12.7-32.14",
    style: {
      fill: "url(#icon_distance-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.06 52.43c0-5.75-4.66-10.42-10.42-10.42s-10.42 4.66-10.42 10.42c0 5.75 4.66 10.42 10.42 10.42 5.75 0 10.41-4.67 10.41-10.42Zm-16.54 0a6.12 6.12 0 1 1 6.12 6.12c-3.38 0-6.11-2.74-6.12-6.12",
    style: {
      fill: "url(#icon_distance-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.73 89.43a7.66 7.66 0 0 0-10.01-4.16c-2.18.9-3.83 2.75-4.46 5.03H31.55a4.14 4.14 0 0 1-4.11-4.17 4.15 4.15 0 0 1 4.11-4.11h12.62c6.93 0 12.54-5.61 12.54-12.54S51.1 56.94 44.17 56.94h-17.4c-1.08-4.1-5.27-6.56-9.38-5.48-4.1 1.08-6.56 5.27-5.48 9.38 1.08 4.1 5.27 6.56 9.38 5.48a7.7 7.7 0 0 0 5.37-5.08h17.52c4.55-.02 8.26 3.65 8.28 8.2s-3.65 8.26-8.2 8.28h-12.7c-4.66 0-8.44 3.78-8.44 8.44s3.78 8.44 8.44 8.44h41.75c.07.23.15.46.25.69 1.63 3.91 6.13 5.75 10.03 4.12 3.88-1.62 5.73-6.07 4.14-9.97ZM20.65 62.01a3.37 3.37 0 1 1 1.83-4.4 3.37 3.37 0 0 1-1.83 4.4m61.28 33.47a3.37 3.37 0 1 1 1.83-4.4c.72 1.71-.08 3.67-1.79 4.39-.01 0-.03.01-.04.02Z",
    style: {
      fill: "url(#icon_distance-01_svg2__e)"
    }
  }));
};
export default SvgIconDistance01;